import { AnimationDirection, DialogAnimationType } from "@progress/kendo-angular-dialog";

export class AnimationConfiguratorService {
    public myAnimation = true;
    public duration = 400;
    public type: DialogAnimationType = "zoom";
    public direction: AnimationDirection = "down";
  }